<template>
  <div :style="history.origin_key === 1 ? 'text-align: -webkit-right; text-align: right;' :
               history.origin_key > 1 ? 'text-align: -webkit-center; text-align: center;' :
               ''">

    <!--Label Balloon-->
  <div v-if="(history.origin_key === 2 || history.origin_key === 4)
      && lengthSplitTextHistoryPipe(history.text) === 1
      && formatMessage(history.text).length < 100"
     class="system-notification">

  <!-- Linha 1: ícone + título -->
  <div class="notification-header">
    <Info :size="16" color="#4a90e2" />
    <span class="notification-title">
      {{ history.origin_key === 2 ? getTranslations('expression_1093')
         : getTranslations('expression_45') }}
    </span>
  </div>

  <!-- Linha 2: mensagem -->
  <div class="notification-body" v-html="formatMessage(history.text)"></div>

  <!-- Linha 3: data/hora -->
  <div class="notification-time">{{ history.created }}</div>
</div>



      <div v-else>
      <!--TODO: O load deve aparecer somente nas mensagens que falharam -->
      <!--TODO: Acrescentar "&& history.failed" -->
      <i v-b-tooltip.bottom
         @click.prevent="resendMsg(history)"
         v-if="history.origin_key === 1 && history.status_key == 3 && getChannelObject('id', history.channel_id).integrations[11].status_key"
         class="fas fa-redo fa-lg mr-2 cursor-pointer"
         :title="history.data && history.data.message"
      >
      </i>

      <!-- <div :class="history.origin_key === 1 ? 'operator' :
             history.origin_key === 2 ? 'system pt-3' :
             history.origin_key === 3 ? 'api pt-3' :
             history.origin_key === 4 ? 'api pt-3' :
             'lead'"
     class="balloon px-3" -->
     <div :class="(history.origin_key === 2 || history.origin_key === 4) ? 'system-long-message' :
             history.origin_key === 1 ? 'operator' :
             history.origin_key === 3 ? 'api pt-3' :
             'lead'"
     class="balloon px-3"

     @mouseover.prevent="previewChevron(history.id)"
     @mouseleave.prevent="previewChevron(null)">

  <!-- Show expression_1093 or 45 for long system messages -->
  <div v-if="history.origin_key === 2 || history.origin_key === 4"
       class="pb-1"
       style="font-weight: 500; font-size: 13px; color: #555;">
       <Info :size="16" color="#4a90e2" style="margin-right: 4px;" />
    {{ history.origin_key === 2 ? getTranslations('expression_1093') : getTranslations('expression_45') }}:
  </div>


        <!--REPLY CONTENT PREVIEW-->
        <div v-if="history.history_id"
             class="pt-1 pb-1">
          <div class="d-flex my-0"
               :class="history.origin_key === 0 ? 'callout-primary' :
                   history.origin_key === 1 ? 'callout-ballon-operator' :
                   'callout-info'"
               :style="history.origin_key === 1 ? 'background: rgb(100 169 128 / 10%)' :
                   'background: rgb(0 0 0 / 7%)'"
               style="border-radius: 6px;
                font-size: 11px;
                padding: 6px;">
            <div class="pl-1 cursor_default pr-2 w-100">
              <div class="row">
                <div class="col-12 pt-2 pb-0 text-left">
                  <strong :class="history.origin_key === 0 ? 'text-callout-primary' :
                              history.origin_key === 1 ? 'text-callout-ballon-operator' :
                             'text-callout-info'">
                    {{
                      history.reply_origin_key === 1 ? getTranslations('expression_1096') :
                        history.reply_origin_key === 2 ? getTranslations('expression_1093') :
                          history.reply_origin_key === 3 ? getTranslations('expression_368') :
                            getLeadObject('id', getTicketObject('id', history.ticket_id).lead_id).name
                    }}
                  </strong>
                </div>
              </div>
              <div class="row">
                <div class="col-12 pt-1 pb-2 cursor_default text-left">
                  <i v-if="['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(history.reply_mime_type_file)" class="bx bxs-camera pr-1"></i>
                  <i v-else-if="['application/pdf'].includes(history.reply_mime_type_file)" class="bx bxs-file-pdf pr-1"></i>
                  <i v-else-if="['video/mpeg', 'video/mp4'].includes(history.reply_mime_type_file)" class="bx bxs-camera-movie pr-1"></i>
                  <i v-else-if="['audio/mp3', 'audio/mp4', 'audio/ogg', 'audio/x-m4a', 'audio/mpeg', 'video/webm', 'audio/x-aac', 'audio/x-wav'].includes(history.reply_mime_type_file)" class="bx bxs-microphone pr-1"></i>
                  <i v-else-if="['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(history.reply_mime_type_file)" class="fa fa-file-word pr-1"></i>
                  <i v-else-if="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(history.reply_mime_type_file)" class="fa fa-file-excel pr-1"></i>
                  <i v-else-if="history.reply_url_file" class="bx bx-file pr-1"></i>
                  <i v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'location'" class="bx bxs-map pr-1"></i>
                  <i v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'vcard'" class="bx bxs-user pr-1"></i>
                  <i v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'hsm'" class="bx bx-copy-alt pr-1"></i>
                  <i v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'buttons'" class="bx bx-copy-alt pr-1"></i>
                  <i v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'sections'" class="bx bx-menu-alt-right pr-1"></i>
                  <span v-b-tooltip.bottom
                        v-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'location'"
                        :title="getSplitTextHistoryPipe(history.reply_text).address">
                {{ (getSplitTextHistoryPipe(history.reply_text).address ? getSplitTextHistoryPipe(history.reply_text).address : getTranslations('expression_866')) | truncate(30) }}
              </span>
                  <span v-b-tooltip.bottom
                        v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'vcard'"
                        :title="getSplitTextHistoryPipe(history.reply_text).address">
                {{ (getSplitTextHistoryPipe(history.reply_text).name ? getSplitTextHistoryPipe(history.reply_text).name : getTranslations('expression_866')) | truncate(30) }}
              </span>
                  <span v-b-tooltip.bottom
                        v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'hsm'"
                        :title="getSplitTextHistoryPipe(history.reply_text).body">
                {{ (getSplitTextHistoryPipe(history.reply_text).body ? getSplitTextHistoryPipe(history.reply_text).body : getTranslations('expression_866')) | truncate(30) }}
              </span>
                  <span v-b-tooltip.bottom
                        v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'buttons'"
                        :title="getSplitTextHistoryPipe(history.reply_text).text">
                {{ (getSplitTextHistoryPipe(history.reply_text).text ? getSplitTextHistoryPipe(history.reply_text).text : getTranslations('expression_866')) | truncate(30) }}
              </span>
                  <span v-b-tooltip.bottom
                        v-else-if="lengthSplitTextHistoryPipe(history.reply_text) > 1 && getSplitTypeTextHistoryPipe(history.reply_text) === 'sections'"
                        :title="getSplitTextHistoryPipe(history.reply_text).text">
                {{ (getSplitTextHistoryPipe(history.reply_text).text ? getSplitTextHistoryPipe(history.reply_text).text : getTranslations('expression_866')) | truncate(30) }}
              </span>
                  <span v-else v-b-tooltip.bottom
                        :title="history.reply_text">
                {{ (history.reply_text ? history.reply_text : getTranslations('expression_866')) | truncate(30) }}
              </span>
                </div>
              </div>
            </div>
            <div v-if="history.reply_url_file">

              <!-- IMAGE FILES -->
              <div class="reply-img"
                   data-toggle="modal"
                   data-target="#viewMediaModal"
                   @click.prevent="setMedia(history.reply_url_file)"
                   :style="`background-image: url('${history.reply_url_file}'); cursor: pointer;`"
                   v-if="['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(history.reply_mime_type_file)">
              </div>

              <!-- PDF FILES -->
              <div style="max-height: 40px;
                min-height: 40px;
                min-width: 40px;
                max-width: 40px;
                display: flex;
                border-radius: 6px;
                align-items: center;
                justify-content: center;"
                   class="bg-light cursor_pointer reply-img"
                   @click.prevent="openUrl(history.reply_url_file)"
                   v-else-if="['application/pdf'].includes(history.reply_mime_type_file)">
                <i class="bx bxs-file-pdf bx-sm text-gray-700"></i>
              </div>

              <!-- VIDEO FILES -->
              <div style="max-height: 40px;
                min-height: 40px;
                min-width: 40px;
                max-width: 40px;
                display: flex;
                border-radius: 6px;
                align-items: center;
                justify-content: center;"
                   class="bg-light cursor_pointer reply-img"
                   @click.prevent="openUrl(history.reply_url_file)"
                   v-else-if="['video/mpeg', 'video/mp4'].includes(history.reply_mime_type_file)">
                <i class="bx bxs-camera-movie bx-sm text-gray-700"></i>
              </div>

              <!-- AUDIO FILES -->
              <div style="max-height: 40px;
                min-height: 40px;
                min-width: 40px;
                max-width: 40px;
                display: flex;
                border-radius: 6px;
                align-items: center;
                justify-content: center;"
                   class="bg-light cursor_pointer reply-img"
                   @click.prevent="openUrl(history.reply_url_file)"
                   v-else-if="['audio/mp3', 'audio/mp4', 'audio/ogg', 'audio/x-m4a', 'audio/mpeg', 'video/webm', 'audio/x-aac', 'audio/x-wav'].includes(history.reply_mime_type_file)">
                <i class="bx bxs-microphone bx-sm text-gray-700"></i>
              </div>

              <!-- WORD -->
              <div v-else-if="['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(history.reply_mime_type_file)"
                   style="max-height: 40px;
                min-height: 40px;
                min-width: 40px;
                max-width: 40px;
                display: flex;
                border-radius: 6px;
                align-items: center;
                justify-content: center;"
                   class="bg-light cursor_pointer reply-img"
                   @click.prevent="openUrl(history.reply_url_file)">
                <i class="fa fa-file-word bx-sm text-gray-700"></i>
              </div>

              <!-- EXCEL -->
              <div v-else-if="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(history.reply_mime_type_file)"
                   style="max-height: 40px;
                min-height: 40px;
                min-width: 40px;
                max-width: 40px;
                display: flex;
                border-radius: 6px;
                align-items: center;
                justify-content: center;"
                   class="bg-light cursor_pointer reply-img"
                   @click.prevent="openUrl(history.reply_url_file)">
                <i class="fa fa-file-excel bx-sm text-gray-700"></i>
              </div>

              <!-- GENERIC FILES -->
              <div v-else-if="history.reply_url_file && history.reply_mime_type_file !== 'dropbox'">
                <div style="max-height: 40px;
                        min-height: 40px;
                        min-width: 40px;
                        max-width: 40px;
                        margin-top: 0;
                        display: flex;
                        border-radius: 6px;
                        align-items: center;
                        justify-content: center;"
                     class="bg-light cursor_pointer reply-img"
                     @click.prevent="openUrl(history.reply_url_file)">
                  <i class="bx bx-file bx-sm text-gray-700"></i>
                </div>
              </div>

              <!-- CLOUD (DROPBOX) FILES -->
              <div v-else-if="['dropbox'].includes(history.reply_mime_type_file)">
                <div style="max-height: 40px;
                      min-height: 40px;
                      min-width: 40px;
                      max-width: 40px;
                      margin-top: 0;
                      display: flex;
                      border-radius: 6px;
                      align-items: center;
                      justify-content: center;"
                     class="bg-light cursor_pointer reply-img"
                     @click.prevent="openUrl(history.reply_url_file)">
                  <i class="bx bx-cloud-download bx-sm text-gray-700"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--CONTENT FILE TYPES-->
        <div class="pb-1"
             style="display: block;
                justify-content: center;">

          <!-- IMAGE FILES -->
          <div class="pb-1"
               v-if="['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(history.mime_type_file)   && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))">
            <img @click.prevent="setMedia(history.url_file)"
                 data-toggle="modal"
                 data-target="#viewMediaModal"
                 class="shadow-sm cursor_pointer bg-light"
                 :src="history.url_file"
                 :style="($mq === 'mobile' || $mq === 'tablet') ? 'max-width: 200px;' : 'max-width: 200px;'"
                 style="margin-top: .3rem; border-radius: 8px; float: none; margin-right: auto;">
          </div>

          <!-- PDF FILES -->
          <div style="max-height: 100px;
                min-height: 100px;
                min-width: 160px;
                max-width: 160px;
                margin-top: .3rem;
                display: flex;
                border-radius: 8px;
                align-items: center;
                justify-content: center;"
               class="bg-light shadow-sm cursor_pointer pb-1"
               @click.prevent="openUrl(history.url_file)"
               v-else-if="['application/pdf'].includes(history.mime_type_file)  && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))">
            <i class="bx bxs-file-pdf bx-md text-gray-700"></i>
          </div>

          <!-- VIDEO FILES -->
          <div class="pb-1"
               v-else-if="['video/mpeg', 'video/mp4'].includes(history.mime_type_file)   && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))">
            <video class="bg-gradient-secondary shadow-sm" width="180" height="180"
                   style="margin-top: .3rem; border-radius: 8px;" controls>
              <source :src="history.url_file" type="video/mp4">
            </video>
          </div>

          <!-- AUDIO FILES -->
          <div class="pt-2 pb-1"
               v-else-if="this.$route.name !== 'ReportsVoip' && ['audio/mp3', 'audio/mp4', 'audio/ogg', 'audio/x-m4a', 'audio/mpeg', 'video/webm', 'audio/x-aac', 'audio/x-wav'].includes(history.mime_type_file)  && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))">
            <audio controls controlsList="nodownload" class="audio"
              style="margin: -10px; width: 320px; padding-right: 20px;">
              <source :src="history.url_file" type="audio/mpeg">
            </audio>
          </div>

          <!-- WORD -->
          <div v-else-if="['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(history.mime_type_file)  && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))"
               style="max-height: 100px;
                min-height: 100px;
                min-width: 160px;
                max-width: 160px;
                margin-top: .3rem;
                display: flex;
                border-radius: 8px;
                align-items: center;
                justify-content: center;"
               class="bg-light shadow-sm cursor_pointer pb-1"
               @click.prevent="openUrl(history.url_file)">
            <i class="fa fa-file-word bx-md text-gray-700"></i>
          </div>

          <!-- EXCEL -->
          <div v-else-if="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(history.mime_type_file)  && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))"
               style="max-height: 100px;
                min-height: 100px;
                min-width: 160px;
                max-width: 160px;
                margin-top: .3rem;
                display: flex;
                border-radius: 8px;
                align-items: center;
                justify-content: center;"
               class="bg-light shadow-sm cursor_pointer pb-1"
               @click.prevent="openUrl(history.url_file)">
            <i class="fa fa-file-excel bx-md text-gray-700"></i>
          </div>

          <!-- GENERIC FILES -->
          <div v-else-if="history.url_file && lengthSplitTextHistoryPipe(history.text) === 1 && !['dropbox'].includes(history.mime_type_file)  && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))"
               style="width: 100%;
                  position: relative;
                  display: flex;"
               :style="history.origin_key === 1 ? 'justify-content: end;' : ''">
            <div style="max-height: 100px;
                    min-height: 100px;
                    min-width: 100px;
                    max-width: 100px;
                    margin-top: .3rem;
                    display: flex;
                    border-radius: 8px;
                    align-items: center;
                    justify-content: center;"
                 class="bg-light shadow-sm cursor_pointer pb-1"
                 @click.prevent="openUrl(history.url_file)">
              <i class="bx bx-file bx-md text-gray-700"></i>
            </div>
          </div>

          <!-- CLOUD (DROPBOX) FILES -->
          <div v-else-if="['dropbox'].includes(history.mime_type_file)  && !['location', 'vcard', 'sms', 'email', 'voip', 'hsm', 'buttons', 'sections'].includes(getSplitTypeTextHistoryPipe(history.text))"
               style="width: 100%;
                  position: relative;
                  display: flex;"
               :style="history.origin_key === 1 ? 'justify-content: end;' : ''">
            <div v-b-tooltip.bottom
                 :title="getTranslations('expression_1127')"
                 style="max-height: 100px;
                      min-height: 100px;
                      min-width: 100px;
                      max-width: 100px;
                      margin-top: .3rem;
                      margin-bottom: 3px;
                      display: flex;
                      border-radius: 8px;
                      align-items: center;
                      justify-content: center;"
                 class="bg-light shadow-sm cursor_pointer pb-1"
                 @click.prevent="openUrl(history.url_file)">
              <i class="bx bx-cloud-download bx-md text-gray-700"></i>
            </div>
          </div>

          <!-- SPECIALS -->
          <div class="pb-1 w-100" v-if="lengthSplitTextHistoryPipe(history.text) > 1">
            <!-- SPECIALS - LOCATION -->
            <div v-if="getSplitTypeTextHistoryPipe(history.text) === 'location'">
              <div class="pt-1">
                <iframe width="100%" height="120" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                        :src="`https://maps.google.com/maps?width=auto&height=auto&hl=en&q=${getSplitTextHistoryPipe(history.text).latitude},${getSplitTextHistoryPipe(history.text).longitude}&area=01000&t=&z=15&ie=UTF8&iwloc=B&output=embed&callback=test`"
                        style="padding: 0; margin: 0 0 -6px; border-radius: 8px;">
                </iframe>
              </div>
              <div class="pt-2">
                {{ getSplitTextHistoryPipe(history.text_clean).address }}
              </div>
            </div>
            <!-- SPECIALS - VCARD -->
            <div v-else-if="getSplitTypeTextHistoryPipe(history.text) === 'vcard'">
              <div class="d-flex py-1"
                   :style="history.origin_key > 0 ? 'justify-content: space-between;' :
                       'justify-content: flex-start;'">
                <div class="pl-2">
                  <div class="avatar_content" style="padding: 0 0px 0 10px;">
                    <div style="width: 40px; height: 40px;"
                         class="pl-2 avatar">
                      <img style="min-height: 40px;
                                 min-width: 40px;
                                 width: 40px;
                                 height: 40px;
                                 margin-left: -40px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                           class="avatar-img shadow-sm"
                           :src="lead_avatar"/>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
             <span class="font-weight-bold d-block pt-1" style="font-size: 13px;">
               {{ getSplitTextHistoryPipe(history.text).name }}
             </span>
                  </div>
                  <div>
                    <small style="font-size: 11px;">
             <span>
               {{ getSplitTextHistoryPipe(history.text).phone }}
             </span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <!-- SPECIALS - SMS -->
            <div v-else-if="getSplitTypeTextHistoryPipe(history.text) === 'sms'">
              <div class="d-flex py-1">
                <div class="pl-1">
                  <div class="avatar_content" style="padding: 0 0px 0 10px;">
                    <div style="width: 40px; height: 40px;"
                         class="pl-1 avatar">
                      <i style="min-height: 40px;
                                 min-width: 40px;
                                 width: 40px;
                                 height: 40px;
                                 margin-left: -40px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         v-b-tooltip.bottom
                         :title="getTranslations('expression_534')"
                         class="bg-light shadow-sm bx bx-message-alt-detail bx-sm text-gray-600"/>
                    </div>
                  </div>
                </div>
                <div class="d-flex" style="align-items: center;">
                  <div>
             <span class="d-block pt-1" style="font-size: 13px;">
               {{ getSplitTextHistoryPipe(history.text).text }}
             </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- SPECIALS - EMAIL -->
            <div v-else-if="getSplitTypeTextHistoryPipe(history.text) === 'email'">
              <div class="d-flex py-1 w-100" style="justify-content: space-between;">
                <div class="pl-1">
                  <div class="avatar_content" style="padding: 0 0px 0 10px;">
                    <div style="width: 40px; height: 40px;"
                         class="pl-2 avatar">
                      <i style="min-height: 40px;
                                 min-width: 40px;
                                 width: 40px;
                                 height: 40px;
                                 margin-left: -40px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         v-b-tooltip.bottom
                         :title="getTranslations('expression_161')"
                         class="bg-light shadow-sm bx bx-envelope bx-sm text-gray-600"/>
                    </div>
                  </div>
                </div>
                <div class="d-flex" style="align-items: center;">
                  <div>
             <span class="font-weight-bold d-block pt-1" style="font-size: 13px;">
               {{ getSplitTextHistoryPipe(history.text).subject }}
             </span>
                  </div>
                </div>
              </div>
              <div>
                <span v-html="getSplitTextHistoryPipe(history.text).text" style="font-size: 13px;"></span>
              </div>
            </div>
            <!-- SPECIALS - VOIP -->
            <div v-else-if="getSplitTypeTextHistoryPipe(history.text) === 'voip'">
              <div class="d-flex py-1">
                <div class="pl-1">
                  <div class="avatar_content" style="padding: 0 0px 0 10px;">
                    <div style="width: 40px; height: 40px;"
                         class="pl-2 avatar">
                      <i style="min-height: 40px;
                                 min-width: 40px;
                                 width: 40px;
                                 height: 40px;
                                 margin-left: -40px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         v-b-tooltip.bottom
                         :title="getTranslations('expression_535')"
                         class="bg-light shadow-sm bx bx-phone-call bx-sm text-gray-600"/>
                    </div>
                  </div>
                </div>
                <div class="d-flex pr-1" style="align-items: center; width: 240px;">
                  <audio class="audio" style="margin: -15px; border-radius: 8px;" controls controlsList="nodownload">
                    <source :src="history.url_file" type="audio/mpeg">
                  </audio>
                </div>
              </div>
            </div>
            <!-- SPECIALS - HSM -->
            <div v-else-if="getSplitTypeTextHistoryPipe(history.text) === 'hsm'">
              <div class="d-flex py-1">
                <div class="pl-1">
                  <div class="avatar_content" style="padding: 0 0px 0 10px;">
                    <div style="width: 40px; height: 40px;"
                         class="pl-1 avatar">
                      <i style="min-height: 40px;
                                 min-width: 40px;
                                 width: 40px;
                                 height: 40px;
                                 margin-left: -40px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         v-b-tooltip.bottom
                         :title="getTranslations('expression_536')"
                         class="bg-light shadow-sm bx bx-copy-alt bx-sm text-gray-600"/>
                    </div>
                  </div>
                </div>
                <div class="d-flex" style="align-items: center;">
                  <div>
                    <!-- IMAGE FILES -->
                    <div class="pb-1"
                         v-if="['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(history.mime_type_file) ">
                      <img @click.prevent="setMedia(history.url_file)"
                           data-toggle="modal"
                           data-target="#viewMediaModal"
                           class="shadow-sm cursor_pointer bg-light"
                           :src="history.url_file"
                           :style="($mq === 'mobile' || $mq === 'tablet') ? 'max-width: 200px;' : 'max-width: 200px;'"
                           style="margin-top: .3rem; border-radius: 8px; float: none; margin-right: auto;">
                    </div>
                    <!-- PDF FILES -->
                    <div style="max-height: 100px;
                            min-height: 100px;
                            min-width: 100px;
                            max-width: 100px;
                            margin-top: .3rem;
                            display: inline-grid;
                            border-radius: 8px;
                            align-items: center;
                            justify-content: center;"
                         class="bg-light shadow-sm cursor_pointer pb-1 mb-1"
                         @click.prevent="openUrl(history.url_file)"
                         v-else-if="['application/pdf'].includes(history.mime_type_file)">
                      <i class="bx bxs-file-pdf bx-md text-gray-700"></i>
                    </div>
                    <!-- VIDEO FILES -->
                    <div class="pb-1"
                         v-else-if="['video/mpeg', 'video/mp4'].includes(history.mime_type_file)">
                      <video class="bg-gradient-secondary shadow-sm" width="200" height="180"
                             style="margin-top: .3rem; border-radius: 8px;" controls>
                        <source :src="history.url_file" type="video/mp4">
                      </video>
                    </div>
                    <!-- AUDIO FILES -->
                    <div class="pt-2 pb-1"
                         v-else-if="['audio/mp3', 'audio/mp4', 'audio/ogg', 'audio/x-m4a', 'audio/mpeg', 'video/webm', 'audio/x-aac', 'audio/x-wav'].includes(history.mime_type_file)">
                      <audio class="audio" style="margin: -15px; border-radius: 8px;" controls controlsList="nodownload">
                        <source :src="history.url_file" type="audio/mpeg">
                      </audio>
                    </div>
                    <div class="d-block pt-1" style="font-family: 'Product Sans Medium Regular'; font-size: 14px;">
                      {{ getSplitTextHistoryPipe(history.text).header ? getSplitTextHistoryPipe(history.text).header : '' }}
                    </div>
                    <span class="d-block pt-1" style="font-size: 13px;">
                  <span v-html="formatMessage(getSplitTextHistoryPipe(history.text).body)"></span>

                </span>
                    <div v-if="getSplitTextHistoryPipe(history.text).buttons && getSplitTextHistoryPipe(history.text).buttons.length > 0" class="row pt-3 pb-2 pr-2">
                      <div v-for="(btn, index) in getSplitTextHistoryPipe(history.text).buttons"
                           :key="index"
                           :class="index >= 2 ? 'col-12' : 'col-6'"
                           style="min-width: max-content;"
                           class="p-1">
                        <div class="d-block cursor_default btn shadow-sm" style="background-color:#192830;color:white; font-size: 12px; padding: 4px 8px;">
                          <i v-if="btn.type === 'URL' || btn.type === 'PHONE_NUMBER'"
                             :class="btn.type === 'URL' ? 'bx bx-link-external' :
                                 btn.type === 'PHONE_NUMBER' ? 'bx bx-phone' : ''" class="pr-1"></i>
                          {{ btn.text }}
                        </div>
                      </div>
                    </div>
                    <small class="d-block pb-0 pt-1" style="font-size: 11px;">
                      <i>
                        {{ getSplitTextHistoryPipe(history.text).footer ? getSplitTextHistoryPipe(history.text).footer : '' }}
                      </i>
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <!-- SPECIALS - HSM / BUTTONS -->
            <div v-else-if="getSplitTypeTextHistoryPipe(history.text) === 'buttons'">
              <div class="d-flex buttons py-1">
                <div class="col pl-2" style="max-width: 65px;">
                  <div class="avatar_content" style="padding: 0 0px 0 10px;">
                    <div style="width: 40px; height: 40px;"
                         class="pl-1 avatar">
                      <i style="min-height: 40px;
                                 min-width: 40px;
                                 width: 40px;
                                 height: 40px;
                                 margin-left: -40px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         v-b-tooltip.bottom
                         :title="getTranslations('expression_536')"
                         class="bg-light shadow-sm bx bx-copy-alt bx-sm text-gray-600"/>
                    </div>
                  </div>
                </div>
                <div class="col d-flex" style="align-items: center;">
                  <div style="min-width: 100%;">
                    <div class="d-block pt-1"
                         style="min-width: 100%; font-family: 'Product Sans Medium Regular'; font-size: 14px;">
                      {{ getSplitTextHistoryPipe(history.text) ? getSplitTextHistoryPipe(history.text).text : '' }}
                    </div>
                    <span class="d-block pt-1" style="font-size: 13px;">
                <span v-html="formatMessage(getSplitTextHistoryPipe(history.text).body)"></span>

              </span>
                    <div v-if="getSplitTextHistoryPipe(history.text).buttons && getSplitTextHistoryPipe(history.text).buttons.length > 0" class="row pt-3 pb-2 pr-2">
                      <div v-for="(btn, index) in getSplitTextHistoryPipe(history.text).buttons"
                           :key="index"
                           :class="index === 0 && getSplitTextHistoryPipe(history.text).buttons.length === 1 ?
                              'col-12' : index >= 2 ? 'col-12' : 'col-6'"
                           style="min-width: max-content;"
                           class="p-1">
                        <div class="d-block cursor_default btn shadow-sm" style="background-color:#192830;color:white; font-size: 12px; padding: 4px 8px;">
                          <i v-if="btn.type === 'URL' || btn.type === 'PHONE_NUMBER'"
                             :class="btn.type === 'URL' ? 'bx bx-link-external' :
                                 btn.type === 'PHONE_NUMBER' ? 'bx bx-phone' : ''" class="pr-1"></i>
                          {{ btn.reply.title }}
                        </div>
                      </div>
                    </div>
                    <small class="d-block pb-0 pt-1" style="font-size: 11px;">
                      <i>
                        {{ getSplitTextHistoryPipe(history.text).footer ? getSplitTextHistoryPipe(history.text).footer : '' }}
                      </i>
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <!-- SPECIALS - HSM / SECTIONS -->
            <div v-else-if="getSplitTypeTextHistoryPipe(history.text) === 'sections'">
              <div class="d-flex buttons py-1">
                <div class="col pl-2" style="max-width: 65px;">
                  <div class="avatar_content" style="padding: 0 0px 0 10px;">
                    <div style="width: 40px; height: 40px;"
                         class="pl-1 avatar">
                      <i style="min-height: 40px;
                                 min-width: 40px;
                                 width: 40px;
                                 height: 40px;
                                 margin-left: -40px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                         v-b-tooltip.bottom
                         :title="getTranslations('expression_536')"
                         class="bg-light shadow-sm bx bx-copy-alt bx-sm text-gray-600"/>
                    </div>
                  </div>
                </div>
                <div class="col d-flex" style="align-items: center;">
                  <div style="min-width: 100%;">
                    <div class="d-block pt-1"
                         style="min-width: 100%; font-family: 'Product Sans Medium Regular'; font-size: 14px;">
                      {{ getSplitTextHistoryPipe(history.text) ? getSplitTextHistoryPipe(history.text).text : '' }}
                    </div>
                    <span class="d-block pt-1" style="font-size: 13px;">
                  <span v-html="formatMessage(getSplitTextHistoryPipe(history.text).body)"></span>

                </span>
                    <div v-if="section_key && getSplitTextHistoryPipe(history.text) && getSplitTextHistoryPipe(history.text).sections.length > 0"
                         class="row animated--grow-in pt-3 pb-2 pr-2">
                      <div v-for="(section, index) in getSplitTextHistoryPipe(history.text).sections"
                           :key="`section_${index}`"
                           style="min-width: max-content;"
                           class="p-1 col-12">
                        <div class="d-block title-color cursor_default btn bg-white rounded-0 shadow-sm" style="font-size: 12px; padding: 4px 8px;">
                          <i v-if="section.type === 'URL' || section.type === 'PHONE_NUMBER'"
                             :class="section.type === 'URL' ? 'bx bx-link-external' :
                                 section.type === 'PHONE_NUMBER' ? 'bx bx-phone' : ''" class="pr-1"></i>
                          {{ section.title }}
                        </div>
                      </div>
                    </div>
                    <small class="d-block pb-0 pt-1" style="font-size: 11px;">
                      <i>
                        {{ getSplitTextHistoryPipe(history.text).footer ? getSplitTextHistoryPipe(history.text).footer : '' }}
                      </i>
                    </small>

                    <div @click="section_key = !section_key" class="pt-3">
                      <div class="row pb-2 pr-2">
                        <div style="min-width: max-content;"
                             class="p-1 col-12">
                          <div style="background: #f2eee3!important;" class="d-block title-color cursor_default btn rounded-0 shadow-sm" >
                            <i class="bx bx-menu-alt-right pr-1"></i>
                            {{ !section_key ?`Mostrar as ${getSplitTextHistoryPipe(history.text).sections.length} opções` : 'Minimizar' }}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="pt-1" v-html="formatMessage(history.text)" style="font-size: 14px;"></div>
          </div>

        </div>

        <!-- TEXT -->
        <div class="pb-1 pt-1"
             style="overflow:hidden;
                word-wrap: break-word;
                white-space: pre-wrap;
                font-size: 14px;"
             v-html="formatMessage(history.text)"
             v-if="lengthSplitTextHistoryPipe(history.text) === 1">
        </div>
        <!--
            Condição dos botões de resposta

            Lado direito (Sistema e Operadores):
            `chevron_${history.id}` === hover_id && $route.name === 'Chat' && show_reply && (history.origin_key === 1 || history.origin_key === 2 || history.origin_key === 3)

            Lado esquerdo (LEAD):
            `chevron_${history.id}` === hover_id && $route.name === 'Chat' && show_reply && history.origin_key === 0
        -->

        <!--Responder SYS-->
        <div v-if="!(getChannelObject('id', history.channel_id)
                && getChannelObject('id', history.channel_id).integrations
                && getChannelObject('id', history.channel_id).integrations[9]
                && getChannelObject('id', history.channel_id).integrations[9].status_key)
                && getChannelObject('id', history.channel_id).type_key === 0
                && `chevron_${history.id}` === hover_id
                && $route.name === 'Chat'
                && show_reply
                && [1, 2, 3].includes(history.origin_key)
                && !['sms', 'sendinblue', 'api4com', 'hsm'].includes(getSplitTypeTextHistoryPipe(history.text))"
             style="margin-block: 3px;"
             @click.prevent="setReply(history)"
             class="float-left pr-2 animated--grow-in cursor_pointer d-flex">
          <i class="bx bxs-share pr-1"></i>
          <small style="font-size: 11px;">
            <strong>{{ getTranslations('expression_1097') }}</strong>
          </small>
        </div>

        <!--Status Official SYS-->
        <div v-if="history.status !== null
              && isWhatsappOfficial()
              && [1].includes(history.origin_key)
              && !['sms', 'sendinblue', 'api4com'].includes(getSplitTypeTextHistoryPipe(history.text))"
             style="margin-block: 3px;"
             class="float-left pr-2 cursor_default animated--grow-in d-flex">
          <i :class="history.status === 'pending' ? 'bx bx-time' :
                history.status === 'failed' ? 'bx bx-block' :
                history.status === 'sent' ? 'bx bx-check' :
                history.status === 'delivered' ? 'bx bx-check-double' :
                history.status === 'read' ? 'bx bx-check-double' :
                ''"

             :style="history.status === 'pending' ? 'color: white;' :
                history.status === 'failed' ? '' :
                history.status === 'sent' ? 'color: white;' :
                history.status === 'delivered' ? 'color: white;' :
                history.status === 'read' ? 'color: #00ff09;' :
                ''"
             v-b-tooltip.bottom
             :title="history.status_timestamp"
             class="pr-1"></i>
          <small v-if="`chevron_${history.id}` === hover_id"
                 class="animated--grow-in" style="font-size: 11px;">
            <strong style="color: white;">
              {{
                history.status === 'pending' ? getTranslations('expression_418') :
                  history.status === 'failed' ? getTranslations('expression_1202') :
                    history.status === 'sent' ? getTranslations('expression_417') :
                      history.status === 'delivered' ? getTranslations('expression_1200') :
                        history.status === 'read' ? getTranslations('expression_1201') :
                          ''
              }}
            </strong>
          </small>
        </div>

        <!--Horário-->
        <div :class="history.origin_key === 0 ? 'time-left' :
                 history.origin_key === 1 ? 'time-right' :
                 'time-system'"
             
             class="timer">
          {{ history.created }}
        </div>

        <!--Responder LEAD-->
        <div v-if="!(getChannelObject('id', history.channel_id)
                && getChannelObject('id', history.channel_id).integrations
                && getChannelObject('id', history.channel_id).integrations[9]
                && getChannelObject('id', history.channel_id).integrations[9].status_key)
                && getChannelObject('id', history.channel_id).type_key === 0
                && `chevron_${history.id}` === hover_id
                && $route.name === 'Chat'
                && show_reply
                && history.origin_key === 0
                && !['sms', 'sendinblue', 'api4com', 'hsm'].includes(getSplitTypeTextHistoryPipe(history.text))"
             style="margin-block: 3px;"
             @click.prevent="setReply(history)"
             class="float-right pl-2 animated--grow-in cursor_pointer d-flex">
          <i class="bx bxs-share pr-1"></i>
          <small style="font-size: 11px;">
            <strong>{{ getTranslations('expression_1097') }}</strong>
          </small>
        </div>

        <!--Status Official LEAD - TODO: Verificar necessidade-->
        <div v-if="false && (getChannelObject('id', history.channel_id)
                && getChannelObject('id', history.channel_id).integrations
                && getChannelObject('id', history.channel_id).integrations[9]
                && getChannelObject('id', history.channel_id).integrations[9].status_key)
                && getChannelObject('id', history.channel_id).type_key === 0
                && `chevron_${history.id}` === hover_id
                && history.origin_key === 0
                && !['sms', 'sendinblue', 'api4com'].includes(getSplitTypeTextHistoryPipe(history.text))"
             style="margin-block: 3px;"
             class="float-right pl-2 d-flex">
          <i :class="history.status_key === 0 ? 'bx bx-check text-primary' :
                 history.status_key === 1 ? 'bx bx-check-double text-success' : ''"
             class="pr-1"></i>
          <small style="font-size: 11px;">
            <strong>
              {{ history.status_key === 0 ? 'Pendente' :
              history.status_key === 1 ? 'Enviado' :
                history.status_key === 2 ? 'Entregue' : '' }}
            </strong>
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lead_avatar from "../../assets/img/no-pic-user.png";
import {mapGetters, mapState} from "vuex";
import { Info } from "lucide-vue";
export default {
  name: "ChatBalloonDefault",
   components: {
    Info
  },
  mounted() {
    // this.history.status = 'pending'
  },
  data() {
    return {
      lead_avatar: lead_avatar,
      hover_id: null,
      section_key: false
    }
  },
  props: [
    'history',
    'show_reply'
  ],
  computed: {
    ...mapState(['chat', 'configs']),
  },
  methods: {
    formatMessage(text){
      let t = text.replace(/\*([^*]+)\*/g, '<b>$1</b>');
      //console.log('Text: ', t);
      return t;
    },
    isWhatsappOfficial() {
      if (this.getChannelObject('id', this.history.channel_id).type_key === 0) {
        if(this.getChannelObject('id', this.history.channel_id).integrations) {
          if (this.getChannelObject('id', this.history.channel_id).integrations[9].status_key
            || this.getChannelObject('id', this.history.channel_id).integrations[12]
              && this.getChannelObject('id', this.history.channel_id).integrations[12].status_key) {
            return true
          }
        }
      }
    },
    openUrl(payload) {
      window.open(payload, "_blank");
    },
    setMedia(payload) {
      this.chat.show_media = this.xeroxHelper(payload)
    },
    previewChevron(payload) {
      this.hover_id = payload ? `chevron_${payload}` : null;
    },
    setReply(payload){
      this.chat.history_reply = this.xeroxHelper(payload)
      this.downScrollChat()
      // console.log(this.chat.history_reply)
    },
    lengthSplitTextHistoryPipe(payload) {
      return payload ? payload.split("|").length : 0
    },
    getSplitTypeTextHistoryPipe(payload) {
      return payload ? payload.split("|")[0] : null
    },
    getSplitTextHistoryPipe(payload) {
      return payload && payload.split("|").slice(1) !== undefined ? JSON.parse(payload.split("|").slice(1)) : {}
    },
    resendMsg(history) {
      // console.log('resendMsg', history)
      // this.$store.commit('SET_LOAD_RESEND_MESSAGE', true)
      this.$store.dispatch('resendMessage', history.id)
    }
  }

}
</script>


<style>
.controlBar {
  background-color: transparent!important;
}
.system, .api {
  border-radius: 12px;
  width: 90%;
  text-align: left;
  background-color: #f3f4f6; 
  color: #404040;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.6;
  border: 1px solid #e0e0e0;
}
/* Estilo atualizado para system-long-message */
.system-long-message {
  border-radius: 12px;
  width: 90%;
  text-align: left;
  background-color: #f8f9ff;
  color: #333;
  padding: 16px 20px;
  font-size: 14px;
  line-height: 1.6;
  border: 1px solid #e0e7ff;
  margin: 16px auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  transition: all 0.2s ease;
}

.system-long-message:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #d0d7f7;
}

/* Cabeçalho do sistema */
.notification-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-bottom: 4px;
}
.notification-title {
  font-size: 12px;
  font-weight: 600;
  color: #4a90e2;
}

/* Estilo para o conteúdo da mensagem */
.system-long-message .pb-1.pt-1 {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.6;
}

/* Estilo para links dentro da mensagem */
.system-long-message a {
  color: #4a90e2;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px dotted #4a90e2;
  transition: all 0.2s ease;
}

.system-long-message a:hover {
  color: #2c5282;
  border-bottom: 1px solid #2c5282;
}

/* Estilo para o horário */
.system-long-message .timer {
  font-size: 11px;
  color: #718096;
  margin-top: 8px;
  text-align: right;
}


.reply-img {
  width: 40px;
  height: 40px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover!important;
  background-color: #eee;
}


/* System notification styles - completely separate from chat bubbles */
.system-notification {
  margin: 16px auto;
  /* max-width: 90%; */
  padding: 8px 16px;
  background: #f9fafb;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.notification-chat-content {
  display: flex; /* Changed from inline-flex to flex */
  align-items: flex-start; /* Changed from center to flex-start to align properly with longer content */
  padding: 4px 8px;
  width: 100%;
}

.notification-chat-icon {
  margin-right: 8px;
  color: #666;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding-top: 2px; /* Added small padding to align icon with the first line of text */
  flex-shrink: 0; /* Prevent icon from shrinking */
}

.notification-chat-text {
  font-size: 13px;
  color: #555;
  font-weight: 500;
  text-align: left; /* Ensure text is left-aligned within its container */
  word-break: break-word; /* Allow word breaking for very long words */
}

.notification-chat-time {
  font-size: 11px;
  color: #888;
  margin-top: 1px;
  margin-bottom: 6px;
}

.time-system {
  float: right;
  color: #7b7b7b;
}






.system-notification-1093 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 16px;
  margin: 16px 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f9fafb;
  /* max-width: 90%; */
  margin-left: auto;
  margin-right: auto;
}



.notification-body {
  font-size: 11px;
  color: #333;
  margin-bottom: 4px;
}
.notification-time {
  font-size: 11px;
  color: #718096;
}

</style>

<style src="../../assets/css/pages/chat.css" scoped/>

<style src="../../assets/css/pages/chat.css" scoped/>
